import {defineStore} from "pinia";
import {ref} from "vue";

type AlertType = 'success' | 'error';

interface Alert{
	id : number,
	message: string;
	type : string;
}

export let useAlertsStore = defineStore('alerts', () => {

	let alerts = ref<Alert[]>([]);
	let id = 0;

	function push(type : AlertType, message: string, time : number = 3000) {

		let alert = {
			type, message, id : ++id
		}

		alerts.value.push(alert);

		setTimeout(() => remove(alert), time);

	}

	function pushSuccess(message: string, time : number = 3000) {
		push('success', message, time);
	}

	function pushError(message: string, time : number = 3000) {
		push('error', message, time);
	}

	function remove(alert : Alert){

		let i = alerts.value.indexOf(alert);

		if(i >= 0){
			alerts.value.splice(i, 1)
		}
	}

	return {
		alerts,
		pushSuccess,
		pushError,
		push,
		remove
	}

});